import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { ControlLabel } from 'react-bootstrap';

class LabelContainer extends React.Component {
    render() {
        let placeholderClz;

        if (this.props.data.placeholderHidden) {
            placeholderClz = 'placeholder-tooltip-hidden';
        } else if (this.props.data.placeholderExposed) {
            placeholderClz = 'placeholder-tooltip-exposed';
        } else {
            placeholderClz = 'placeholder';
        }

        const sectionLabel = !!!this.props.data.inputFormat;
        return (
            <div>
                <ControlLabel className={classNames({ 'section-label': sectionLabel, requiredLabel: this.props.requiredLabel })}>
                    {this.props.data.text}
                </ControlLabel>
                {this.props.data.placeholder && (
                    <label className={placeholderClz}>{this.props.data.placeholder}</label>
                )}
                {this.props.data.helper && (
                    <label className={placeholderClz}><span style={{fontWeight: "bold"}}>{this.props.data.helperLabel ? this.props.data.helperLabel : ""}</span>{this.props.data.helper}</label>
                )}
            </div>
        );
    }
}

LabelContainer.propTypes = {
    data: PropTypes.object
};

export default LabelContainer;
